import { render, staticRenderFns } from "./NotificationTemplatesTab.vue?vue&type=template&id=62e24b67&scoped=true"
import script from "./NotificationTemplatesTab.vue?vue&type=script&lang=js"
export * from "./NotificationTemplatesTab.vue?vue&type=script&lang=js"
import style0 from "./NotificationTemplatesTab.vue?vue&type=style&index=0&id=62e24b67&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e24b67",
  null
  
)

export default component.exports